import React, { useState } from 'react';
import { cn } from '@/lib/utils';

const CustomTabs = ({ tabsData }) => {
    const [tabsItem, setTabsItem] = useState(0);

    return (
        <div className="tabs-wrappers">
            <div className={tabsData.length <= 3 ? 'grid grid-cols-1mb-4 sm:mb-0 lg:grid-cols-' + tabsData.length : 'grid grid-cols-1mb-4 sm:mb-0 sm:grid-cols-' + tabsData.length}>
                {tabsData?.map((data, index) => (
                    <button type="button" onClick={() => setTabsItem(index)} className={cn('db-tabBtn', tabsItem === index && 'active')} key={index}>
                        <i className={cn('lab lab-font-size-16', data?.icon)}></i>
                        {data.title}
                    </button>
                ))}
            </div>
            {tabsData?.map((data, index) => (
                <div className={cn('db-tabDiv', tabsItem === index && 'active')}>{data?.content}</div>
            ))}
        </div>
    );
};

export default CustomTabs;
